/**
 * Generated by orval. Do not edit manually.
 */

export type InsiderTrackChoice = (typeof InsiderTrackChoice)[keyof typeof InsiderTrackChoice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsiderTrackChoice = {
  feature_testing: 'feature_testing',
  research_calls: 'research_calls',
} as const
